import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { catalogGraphTranslationRef } from '@backstage/plugin-catalog-graph';

/**
 * Every text of the stock catalog graph in pt-BR (Story 2.3, AC-21): the
 * Grafo page reads its filter titles and options from here, and the stock
 * "Relations" card that other kinds keep says "Relações" / "Ver no grafo".
 * The words match the Catálogo and the Relações card.
 */
export const catalogGraphMessages = TranslationBlueprint.make({
  name: 'byx-catalog-graph',
  params: {
    resource: createTranslationMessages({
      ref: catalogGraphTranslationRef,
      messages: {
        'catalogGraphCard.title': 'Relações',
        'catalogGraphCard.deepLinkTitle': 'Ver no grafo',
        'catalogGraphPage.title': 'Grafo',
        'catalogGraphPage.filterToggleButtonTitle': 'Filtros',
        'catalogGraphPage.supportButtonDescription':
          'Comece a acompanhar o seu componente adicionando-o ao catálogo.',
        'catalogGraphPage.simplifiedSwitchLabel': 'Simplificado',
        'catalogGraphPage.mergeRelationsSwitchLabel': 'Juntar relações',
        'catalogGraphPage.zoomOutDescription':
          'Role para aproximar e arraste para mover. Clique num item para centralizar; clique duplo para abrir a página.',
        'catalogGraphPage.curveFilter.title': 'Curva',
        'catalogGraphPage.curveFilter.curveMonotoneX': 'Curva suave',
        'catalogGraphPage.curveFilter.curveStepBefore': 'Degraus',
        'catalogGraphPage.directionFilter.title': 'Direção',
        'catalogGraphPage.directionFilter.leftToRight': 'Esquerda para direita',
        'catalogGraphPage.directionFilter.rightToLeft': 'Direita para esquerda',
        'catalogGraphPage.directionFilter.topToBottom': 'Cima para baixo',
        'catalogGraphPage.directionFilter.bottomToTop': 'Baixo para cima',
        'catalogGraphPage.maxDepthFilter.title': 'Profundidade máxima',
        'catalogGraphPage.maxDepthFilter.inputPlaceholder': '∞ Sem limite',
        'catalogGraphPage.maxDepthFilter.clearButtonAriaLabel':
          'Limpar a profundidade máxima',
        'catalogGraphPage.selectedKindsFilter.title': 'Tipos',
        'catalogGraphPage.selectedRelationsFilter.title': 'Relações',
      },
    }),
  },
});
